import { Contract } from 'shared/models/contract';
import { useFinancialContext } from '../../FinancialContext';
import ContractPlansTable from '../organisms/ContractPlansTable';
import ContractDetailsBlock from './ContractDetailsBlock';

interface ContractDetailsSectionProps {
  loading?: boolean;
  contract: Contract;
  edit?: boolean;
}
const ContractDetailsSection = ({
  loading,
  contract,
}: ContractDetailsSectionProps) => {
  const { openChangePlanModal } = useFinancialContext();
  const licensePlans = contract.products.filter(
    (p) => p.isLicense && !p.deleted_at,
  );

  return (
    <ContractDetailsBlock
      title="Detalhes do plano"
      loading={loading}
      rightButtons={[
        {
          type: 'edit',
          text: 'Trocar',
          onClick: () => {
            openChangePlanModal(contract);
          },
          isDisabled: contract.periodicity === 'monthly',
          permission: 'contract-change-plan',
        },
      ]}
    >
      <ContractPlansTable loading={loading} plans={licensePlans} />
    </ContractDetailsBlock>
  );
};
export default ContractDetailsSection;
